/***************************************************************************/
"use server";
/***************************************************************************/

import {
  destroyUserLoginSession as _destroyUserLoginSession,
  updateUserLoginSession,
} from "@/server/auth/session.service/user-login-session";

const createOtpLoginSession = async (token: string | undefined) => {
  if (!token) {
    throw new Error("Token is required to create an OTP login session!");
  }

  await updateUserLoginSession(token);
};

async function destroyUserLoginSession() {
  await _destroyUserLoginSession();
}

export { createOtpLoginSession, destroyUserLoginSession };
